import React from "react";
import { Card, CardContent } from "../../components/ui/card";
import { Eye, Star, ArrowUpRight } from "lucide-react";

const NoDataCard = ({ message = "No projects", actionLabel, onAction }) => {
  return (
    <div className="w-full max-w-md mx-auto text-center p-6">
      <div className="flex flex-col items-center gap-4">
        {/* Icon */}
        <div className="p-4">
          <Eye className="w-8 h-8 text-muted-foreground" />
        </div>

        {/* Message */}
        <h2 className="text-xl font-semibold text-[#333]">
          {message}
        </h2>
        <p className="text-sm text-gray-500">
          Looks like there’s nothing here yet. Please check back later!
        </p>
      </div>
    </div>
  );
};

export default NoDataCard;
